import { Card, Col, Row, Image } from "antd";
import React, { useEffect, useState } from "react";
import { ApiService, TemplateTypeFilteredByGroups } from "../api";
import { Link } from "react-router-dom";

const HomePage = () => {
  const [templateTypes, setTemplateTypes] = useState<
    TemplateTypeFilteredByGroups[]
  >([]);

  const getTemplateTypes = async () => {
    const res = await ApiService.apiMainTemplateTypesList("user");

    setTemplateTypes(res);
  };

  useEffect(() => {
    getTemplateTypes();
  }, []);

  return (
    <div>
      {templateTypes.map((tt, index) => (
        <div key={`${tt.id}_${tt.short_name}_${index}`}>
          <h2>{tt.name}</h2>
          <Row gutter={[16, 16]}>
            {tt.filtered_templates.map((t, subindex) => (
              <Col span={4} key={`${t.id}_${t.short_name}_${subindex}`}>
                <Link to={`requests/${t.short_name}/create`}>
                  <Card hoverable={true}>
                    <Card.Grid
                      hoverable={false}
                      style={{ width: "100%", textAlign: "center" }}
                    >
                      <Image width={100} src={t.icon!} preview={false} />
                      <Card.Meta title={t.name}></Card.Meta>
                    </Card.Grid>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
};

export default HomePage;
